import { render, staticRenderFns } from "./BairrosAutocomplete.vue?vue&type=template&id=10277486&scoped=true&"
import script from "./BairrosAutocomplete.vue?vue&type=script&lang=js&"
export * from "./BairrosAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./BairrosAutocomplete.vue?vue&type=style&index=0&id=10277486&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10277486",
  null
  
)

export default component.exports